<template>
  <div class="wrapper">
    <p>众捷国际环境清洁(北京)有限公司@版权所有 京ICP备16040097 联系电话:010-65488518</p>
    <p>地址:
      <a
        target="_blank"
        href="http://map.baidu.com/?newmap=1&ie=utf-8&s=s%26wd%3D%E5%8C%97%E4%BA%AC%E5%B8%82%E5%8F%8C%E6%A1%A5%E8%B7%AF%E8%A5%BF6%E5%8F%B7"
      >北京市 朝阳区 双桥路西6号</a>
    </p>
    <p>
      <a href="http://www.zhongjieguoji.com">http://www.zhongjieguoji.com</a>
    </p>
    <p>未经本公司书面授权、任何机构与个人不得以任何形式摘录或转载本网站内容</p>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.wrapper {
   min-width: 1240px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 30px 0;
  p {
    text-align: center;
    font-size: 12px;
    line-height: 24px;
    a {
      color: #fff;
    }
  }
}
</style>